
import { Loader2, CheckCircle, XCircle } from 'lucide-react';

interface CallbackStatusIconProps {
  status: 'processing' | 'success' | 'error';
}

export const CallbackStatusIcon = ({ status }: CallbackStatusIconProps) => {
  if (status === 'processing') {
    return <Loader2 className="h-12 w-12 text-blue-500 animate-spin" />;
  }
  
  if (status === 'success') {
    return <CheckCircle className="h-12 w-12 text-green-500" />;
  }
  
  return <XCircle className="h-12 w-12 text-red-500" />;
};
